// @flow

import {BieLoaderModal} from 'basic-image-editor/src/BieLoader';

import {Loadable} from 'app/components/general/lazyLoader';
import {type Props} from './ImageEditorLoader';

export const LoadableImageEditor = Loadable<Error, Props>({
  loader: () =>
    import(/* webpackChunkName: "image-editor" */ './ImageEditorLoader'),
  LoadingComponent: BieLoaderModal,
});

export const convertToBlob = (data_URL: string) => {
  var [mimeStr, dataStr] = data_URL.split(',');

  var match = mimeStr.match(/:(.+);/);
  var type = 'image/png';
  if (match != null) {
    type = match[1];
  }
  var binary = atob(dataStr);

  var array = [];

  for (var i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], {type});
};
